export const SEGMENT_DEFAULT_ID = 'Everyone';

export enum SegmentUsageEntities {
  Content = 'Content',
  Experiment = 'Experiment',
  Segment = 'Segment',
}

export interface SegmentUsage {
  id: string;
  usages: {
    entity: SegmentUsageEntities;
    entityId: string;
  }[];
}
